import { render, staticRenderFns } from "./ProviderStreamsComparator.vue?vue&type=template&id=07993abc&scoped=true"
import script from "./ProviderStreamsComparator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderStreamsComparator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderStreamsComparator.vue?vue&type=style&index=0&id=07993abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07993abc",
  null
  
)

export default component.exports